import { Header } from "../components/Header"
import { HeroSection } from "../components/sections/HeroSection"
import { AboutSection } from "../components/sections/AboutSection"
import { ExpertiseSection } from "../components/sections/ExpertiseSection"
import { PartnersSection } from "../components/sections/PartnersSection"
import { ContactSection } from "../components/sections/ContactSection"
import { Footer } from "../components/Footer"

export default function Home() {
    return (
        <div className="min-h-screen bg-black text-white w-full">
            <Header />
            <main>
                <HeroSection />
                <AboutSection />
                <ExpertiseSection />
                <PartnersSection />
                <ContactSection />
            </main>
            <Footer />
        </div>
    )
}
